import { AccountStatus, App, LoadState, accountSourceDataTypeChecker, getAccounts, } from "owa-account-source-list-store";
import { AccountSourceType } from "owa-account-source-list-types";
import type { MailboxInfo } from "owa-client-types";
import { isPstFileMailboxInfo } from "owa-client-types/lib/PstFileMailboxInfo";
import { isPublicFolderMailboxInfo } from "owa-client-types/lib/PublicFolderMailboxInfo";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Determines whether the "All mailboxes" search scope option should be shown.
 *
 * This scope is Monarch-only. Having more than one mail account configured is a Monarch-only
 * scenario, so the presence of multiple accounts is used to gate the option to Monarch. The
 * 'sea-multiAccountSearch' flight acts as the rollout/kill switch.
 *
 * The scope is not applicable when searching within a PST file, the Unified Inbox (UIB), or a
 * public folders mailbox, so it is hidden for those mailbox contexts for now.
 */
export default function shouldShowAllMailboxesScope(selectedMailboxInfo?: MailboxInfo): boolean {
    if (selectedMailboxInfo &&
        (isPstFileMailboxInfo(selectedMailboxInfo) ||
            isPublicFolderMailboxInfo(selectedMailboxInfo) ||
            isUnifiedInboxMailboxInfo(selectedMailboxInfo))) {
        return false;
    }
    
    if (!isGlobalFeatureEnabled("sea-multiAccountSearch")) {
        return false;
    }
    
    const mailAccounts = getAccounts(AccountStatus.Completed, App.Mail);
    return (mailAccounts.length > 1 &&
        mailAccounts.every(
        // Only Office365 user mailboxes run shared folder discovery.
        account => !accountSourceDataTypeChecker.isM365UserMailbox(account) ||
            account.sourceType !== AccountSourceType.Office365 ||
            (account.sharedSources.loadState !== LoadState.NotStarted &&
                account.sharedSources.loadState !== LoadState.Loading)));
}
